import {isEmpty, str_replace} from "../../../helpers/helpers";
import {getAllActiveAgencies} from "../../../../models/agency";
import {getAllActiveRealtors} from "../../../../models/user";
import {getCityById, getCityURL, getDistrict} from "../../../../models/district";
import {inArray} from "../../../helpers/arrays";
import {number_to_text} from "../../../helpers/numbers";
import {getWidgets} from "../../../../models/widget";
import {getNorthCitiesIds} from "../../../../models/area";

export function getItemsLists(page_type, city_id, district_id, page, callback) {
    const districtId = !isEmpty(district_id) ? district_id : city_id;

    return new Promise((resolve, reject) => {
        if (page_type === 'agencies') {
            getAllActiveAgencies(districtId, page).then(result => {
                resolve({result, page_type, city_id, district_id, page, callback})
            }).catch(err => {
                reject(err)
            })
        } else {
            getAllActiveRealtors(districtId, page).then(result => {
                resolve({result, page_type, city_id, district_id, page, callback})
            }).catch(err => {
                reject(err)
            })
        }
    })
}

export function getAgenciesPageBreadcrumbList(asPath) {
    let breadcrumbList = [];

    if (!isEmpty(asPath)) {
        const urls = decodeURI(asPath).split('/');

        if (urls.length) {
            urls.shift(); // remove first value

            let tmpUrl = '';

            for (let url of urls) {
                tmpUrl += '/' + encodeURI(url);

                breadcrumbList.push({
                    name: str_replace('-', ' ', url),
                    url: tmpUrl
                })
            }
        }
    }

    return breadcrumbList;
}

async function makeSearchLink(city, district, page_type = 'agencies') {
    let url = '/';

    if (!isEmpty(city)) {
        url += await getCityURL(city.name)
    }

    url += '/مشاورین-املاک';

    if (!isEmpty(district)) {
        url += '/' + str_replace(' ', '-', district.name);
    }

    if (page_type === 'realtors') {
        url += '?user_type=realtor'
    }

    return url;
}

export async function makeAgenciesSearchUrl(page_type, city_id, district_id) {
    const city = await getCityById(city_id);
    const district = !isEmpty(district_id) ? await getDistrict(district_id) : null;

    return await makeSearchLink(city, district, page_type);
}

export async function getAgenciesPageMetaTitleAnsDescription(city_id, district_id) {
    const city = await getCityById(city_id);
    const district = !isEmpty(district_id) ? await getDistrict(district_id) : null;

    let searchTitle = 'مشاورین املاک';
    let pageTitle = '';
    let pageDescription = '';

    if (!isEmpty(district) && !isEmpty(city)) {
        const isDistrictNameInCityName = (district.name.search(city.name) !== -1);

        searchTitle += ` ${district.name} ${isDistrictNameInCityName ? '' : ' ' + city.name}`;

        if (inArray(district.type, ['region', 'area'])) {
            pageTitle = `مشاورین املاک ${number_to_text(district.name)} ${isDistrictNameInCityName ? '' : ' ' + city.name} (لیست اسامی، شماره تماس و آدرس)`;
            pageDescription = `لیست اسامی، شماره تماس و آدرس مشاورین، بنگاه‌ها و دفاتر املاک متخصص و معروف محله ${number_to_text(district.name)} ${isDistrictNameInCityName ? '' : ' شهر ' + city.name}`
        } else {
            pageTitle = `مشاورین املاک ${district.name} ${isDistrictNameInCityName ? '' : ' ' + city.name} (لیست اسامی، شماره تماس و آدرس)`;
            pageDescription = `لیست اسامی، شماره تماس و آدرس مشاورین، بنگاه‌ها و دفاتر املاک متخصص و معروف محله ${district.name} ${isDistrictNameInCityName ? '' : ' شهر ' + city.name}`
        }
    } else if (!isEmpty(city)) {
        searchTitle += ' ' + city.name;
        pageTitle = `مشاورین املاک ${city.name} (لیست اسامی، شماره تماس و آدرس)`;
        pageDescription = `لیست اسامی، شماره تماس و آدرس مشاورین، بنگاه‌ها و دفاتر املاک متخصص و معروف شهر ${city.name}`;
    }

    return {
        searchTitle,
        pageTitle,
        pageDescription,
        canonicalLink: await makeSearchLink(city, district)
    }
}

export async function getAgenciesPageHotLinks(city_id, district_id) {
    const params = {
        type: 'static_links',
        page: 'realtors',
        section: 'hot_links',
        city_id: city_id,
        district_id: !isEmpty(district_id) ? [district_id] : '',
        count: 20
    };

    let lists = [];

    const result = await getWidgets(params);

    if (!isEmpty(result) && result.widgets && result.widgets.length) {
        for (let widget of result.widgets) {
            lists.push({href: widget.url, hrefAs: widget.url, title: widget.caption})
        }
    } else {
        const links = await makeAgenciesPageHotLinks(city_id, district_id);

        if (links) {
            for (let widget of links) {
                lists.push({href: widget.url, hrefAs: widget.url, title: widget.caption})
            }
        }
    }

    return lists;
}

export async function makeAgenciesPageHotLinks(city_id, district_id) {
    const northCities = await getNorthCitiesIds();
    const city = await getCityById(city_id);
    const district = !isEmpty(district_id) ? await getDistrict(district_id) : null;

    let links = [];

    const city_name = city.name;
    const district_name = !isEmpty(district) ? district.name : null;

    if (inArray(city_id, northCities)) {
        if (!isEmpty(district_name)) {
            links.push({
                url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-ویلا/' + str_replace(' ', '-', district_name),
                caption: 'خرید ویلا در ' + district_name,
            });
        }

        links.push({
            url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-ویلا',
            caption: 'خرید ویلا در ' + city_name,
        });
    } else {
        if (!isEmpty(district_name)) {
            links.push({
                url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-آپارتمان/' + str_replace(' ', '-', district_name),
                caption: 'خرید خانه در ' + district_name,
            });
        }

        links.push({
            url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-آپارتمان',
            caption: 'خرید خانه در ' + city_name,
        });

        links.push({
            url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-آپارتمان/با-وام',
            caption: 'خرید خانه در ' + city_name + ' با وام',
        });
    }

    return links
}
